import styled from 'styled-components';
import { ReactComponent as RawFolderOpenedSVG } from '../../../../assets/icons/folder_opened.svg';

export const IconFolderOpened = styled(RawFolderOpenedSVG)`
`;
